<script lang="ts">
	import Check from 'lucide-svelte/icons/check'
	import Clipboard from 'lucide-svelte/icons/clipboard'
	import Share2 from 'lucide-svelte/icons/share-2'
	import { onMount } from 'svelte'

	import { Button } from '$lib/components/ui/button'
	import * as Dialog from '$lib/components/ui/dialog'
	import * as m from '$lib/paraglide/messages'

	export let urlToCopy: string
	export let text = m.share_button_text()
	export let hideTextOnMobile = true

	// eslint-disable-next-line no-undef
	let copiedTimeout: NodeJS.Timeout | null = null

	onMount(() => () => {
		if (copiedTimeout) {
			clearTimeout(copiedTimeout)
		}
	})
</script>

<Dialog.Root>
	<Dialog.Trigger asChild let:builder>
		<Button
			aria-label={text}
			builders={[builder]}
			size={hideTextOnMobile ? 'responsiveIcon' : 'default'}
			type="button"
			variant="outline"
		>
			<Share2 size="16" />

			<span class={hideTextOnMobile ? 'hidden sm:ml-2 sm:inline' : 'ml-2'}>
				{text}
			</span>
		</Button>
	</Dialog.Trigger>

	<Dialog.Content>
		<Dialog.Header>
			<Dialog.Title>{text}</Dialog.Title>
		</Dialog.Header>

		<div class="flex flex-wrap items-center justify-start gap-2">
			<p
				class="border-input bg-background xs:text-sm flex h-10 flex-1 items-center justify-start rounded-md! border px-3 py-2 text-xs"
			>
				{urlToCopy}
			</p>

			<Button
				aria-label={m.share_button_copy_link()}
				size="icon"
				type="button"
				variant="outline"
				on:click={() => {
					navigator.clipboard.writeText(urlToCopy).then(() => {
						copiedTimeout = setTimeout(() => {
							copiedTimeout = null
						}, 2000)
					})
				}}
			>
				{#if copiedTimeout}
					<Check size="24" />
				{:else}
					<Clipboard size="24" />
				{/if}
			</Button>
		</div>
	</Dialog.Content>
</Dialog.Root>
